// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1Uh3h","upload":"Small_upload__2Bbdj","imageWrap":"Small_imageWrap__8JSvg","removeBtn":"Small_removeBtn__3zCd0"};